import type { GetMailchimpSubscriptionFormParams } from './utils'

export const mailchimpFormDataByHardwareName: Record<string, Omit<GetMailchimpSubscriptionFormParams, 'name'>> = {
  'NVIDIA GeForce RTX 5090': {
    id: '4fc38bd364',
    fId: '00f736e3f0',
    groupId: '78345',
  },
  'NVIDIA GeForce RTX 5080': {
    id: '0cd4fd1d59',
    fId: '00f036e3f0',
    groupId: '78344',
  },
  'NVIDIA GeForce RTX 5070 Ti': {
    id: '5a405d6ee6',
    fId: '00f136e3f0',
    groupId: '78343',
  },
  'NVIDIA GeForce RTX 5070': {
    id: 'a9d61cf961',
    fId: '00f236e3f0',
    groupId: '78342',
  },
  'NVIDIA GeForce RTX 4090': {
    id: '47a0417a3d',
    fId: '00c836e3f0',
    groupId: '78325',
  },
  'NVIDIA GeForce RTX 3090 Ti': {
    id: '10e4ccc46d',
    fId: '00db36e3f0',
    groupId: '78327',
  },
  'NVIDIA GeForce RTX 3090': {
    id: '8dc1e7169f',
    fId: '00d536e3f0',
    groupId: '78326',
  },
  'NVIDIA GeForce RTX 4080': {
    id: '6c59d68b36',
    fId: '00da36e3f0',
    groupId: '78328',
  },
  'NVIDIA GeForce RTX 4070 Ti SUPER': {
    id: '3617b23d0d',
    fId: '00d936e3f0',
    groupId: '78329',
  },
  'NVIDIA GeForce RTX 4070 Ti': {
    id: 'ab85ad6451',
    fId: '00d836e3f0',
    groupId: '78330',
  },
  'NVIDIA GeForce RTX 4060 Ti': {
    id: '5b90900e7f',
    fId: '00df36e3f0',
    groupId: '78331',
  },
  'NVIDIA GeForce RTX 4070': {
    id: '0eeb24689b',
    fId: '00de36e3f0',
    groupId: '78332',
  },
  'NVIDIA GeForce RTX 3080 Ti': {
    id: '539acb35c9',
    fId: '00dd36e3f0',
    groupId: '78333',
  },
  'NVIDIA GeForce RTX 3080': {
    id: '9ddcf3f364',
    fId: '00dc36e3f0',
    groupId: '78334',
  },
  'NVIDIA GeForce RTX 3070 Ti': {
    id: 'ad2e6c4954',
    fId: '00c336e3f0',
    groupId: '78335',
  },
  'NVIDIA GeForce RTX 3070': {
    id: '87e17e35a9',
    fId: '00c236e3f0',
    groupId: '78336',
  },
  'NVIDIA GeForce RTX 3060 Ti': {
    id: 'ee5fd2b75f',
    fId: '00c136e3f0',
    groupId: '78337',
  },
  'NVIDIA GeForce RTX 3060': {
    id: '66f7f1ba73',
    fId: '00c036e3f0',
    groupId: '78338',
  },
  'NVIDIA GeForce RTX 2080 Ti': {
    id: '23833fb7fe',
    fId: '00c736e3f0',
    groupId: '78339',
  },
  'NVIDIA GeForce RTX 2080': {
    id: '41d852a938',
    fId: '00c636e3f0',
    groupId: '78340',
  },
}
